// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"649":"5cb4c284","843":"3738caed"}[chunkId] + ".chunk.js";
};